export default __webpack_public_path__ + "static/media/rwx_order_img_unpaid.ddcae6d6.png";